import React from "react";

import type { LandingPageContent } from "../content/types";

type FaqSectionProps = {
  content: LandingPageContent["faq"];
};

export function FaqSection({ content }: FaqSectionProps) {
  return (
    <section className="db-section section-band" id={content.id} aria-labelledby={`${content.id}-title`}>
      <div className="db-container faq-section">
        <div className="section-heading">
          <p className="section-eyebrow">{content.eyebrow}</p>
          <h2 id={`${content.id}-title`}>{content.title}</h2>
        </div>

        <div className="faq-list">
          {content.items.map((item) => (
            <article className="faq-item" key={item.question}>
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
